<template>
  <form id="form-map" data-vv-scope="settings_form">
    <h3 v-if="Object.keys(filteredColumnsMap).length && isForm">
      <i class="fa"
         :class="columnsMapLocked ? 'fa-lock' : 'fa-unlock-alt'"
         aria-hidden="true"
         @click="setColumnsMapLock(!columnsMapLocked)"></i>
      Map Data
      <span v-if="allowAddingCustomFields && (columnsMapLocked === false || customColumnsMap === null)"
            @click.prevent="customFieldModalShow()"
            class="pull-right options-gear"><i class="icon-settings right"></i></span>
      <hr>
    </h3>
    <div class="form-group" v-for="item in filteredColumnsMap" v-if="isForm"
         :class="{ 'has-error': errors.has('settings_form.columnsMap_'+item.name) }">

      <label>
        <span v-if="isRequired(item)"> *</span>{{ item.label }}
      </label>
      <select class="form-control"
              :name="'columnsMap_'+item.name"
              v-validate="isRequired(item) ? 'required' : ''"
              :data-vv-as="item.label"
              v-model="valueMap[item.name]"
              @change="$emit('update', {value: $event.target.value, ...item})"
              :disabled="columnsMapLocked">
        <option :value="null"
                :selected="isRequired(item)"
                :disabled="isRequired(item)"
                :hidden="isRequired(item)">
        </option>
        <option v-for="field in fieldOptions" :value="field.name">
          {{ field.description }}
        </option>
      </select>

      <span v-show="errors.has('settings_form.columnsMap_'+item.name)"
            class="help-block">{{ errors.first('settings_form.columnsMap_' + item.name) }}</span>
    </div>

    <div class="form-group" v-for="(item, key) in customColumnsMap" v-if="isForm">
      <div>
        <label>{{ item.label }}</label>
        <div class="pull-right">
          <i class="icon-settings" @click.prevent="editCustomFieldModalShow(key)"></i>
          <i class="fa fa-trash" @click.stop="destroyCustomColumn(key)"
             aria-hidden="true"></i>
        </div>
      </div>
      <select class="form-control" :name="'columnsMap_'+item.name" v-validate="'required'"
              :data-vv-as="item.label" v-model="item.value"
              :disabled="columnsMapLocked">
        <option :value="null" selected disabled hidden></option>
        <option v-for="field in fieldOptions" :value="field.name">
          {{ field.description }}
        </option>
      </select>

      <span v-show="errors.has('settings_form.columnsMap_'+item.name)"
            class="help-block">{{ errors.first('settings_form.columnsMap_' + item.name) }}</span>
    </div>

    <form-builder-new-custom-field id="custom-field-modal"
                                   @new-custom-field="newCustomField"/>
    <form-builder-edit-custom-field id="edit-custom-field-modal"
                                    @update-custom-field="editCustomField"
                                    :index="editingCustomColumnIndex"
                                    :original-field-name="editingCustomColumnFieldName"/>
  </form>
</template>


<script>
import { ref, computed, getCurrentInstance, nextTick } from 'vue';

import FormBuilderEditCustomField from "../modals/FormBuilderEditCustomField";
import FormBuilderNewCustomField from "../modals/FormBuilderNewCustomField";


export default {
  props: {
    flatFormItems: {
      type: Array,
      required: true
    },
    customColumnsMap: {
      type: Array,
      required: false
    },
    fieldsMap: {
      type: Array,
      required: false
    },
    columnsMap: {
      type: Object,
      required: false
    },
    isForm: {
      type: Boolean,
    },
    allowAddingCustomFields: {
      type: Boolean,
    },
    isProgram: {
      type: Boolean,
    },
  },
  components: {FormBuilderEditCustomField, FormBuilderNewCustomField},

  emits: ['update'],

  setup(props) {
    const editingCustomColumnIndex = ref(null)
    const editingCustomColumnFieldName = ref('')
    const columnsMapLocked = ref(true)
    const root = getCurrentInstance()

    const setColumnsMapLock = (value) => {
      columnsMapLocked.value = value;
    }

    const customFieldModalShow = () => {
      $('#custom-field-modal').modal('show');
    }

    const destroyCustomColumn = (index) => {
      props.customColumnsMap.splice(index, 1);
    }

    const editCustomFieldModalShow = (key) => {
      editingCustomColumnIndex.value = key;
      editingCustomColumnFieldName.value = props.customColumnsMap[key]['label'];
      $('#edit-custom-field-modal').modal('show');
    }

    const newCustomField = (fieldName) => {
      props.customColumnsMap.push({
        label: fieldName,
        name: fieldName.replace(/\s+/g, '_').toLowerCase(),
        value: null,
        key: 'cf-' + Math.random()
      });
    }

    const valueMap = computed(() => {
      const results = {};

      props.fieldsMap.map(({name, value}) => {
        results[name] = value;
      });

      return results;
    })

    const editCustomField = (index, fieldName) => {
      props.customColumnsMap[index]['label'] = fieldName;
      props.customColumnsMap[index]['name'] = fieldName.replace(/\s+/g, '_').toLowerCase();
    }

    const fieldOptions = computed(() => {
      return props.flatFormItems.filter(f => !['text-entry','row','divider','accordion'].includes(f.type))
    })

    const filteredColumnsMap = computed(() => {
      return Object.entries(props.columnsMap || [])
        .filter(([name, label]) => name !== 'programs' || props.isProgram)
        .map(([name, label]) => {
          return {
            name,
            label
          }
        })
    })

    const validateAll = async () => {
      // XXX: if field is disabled then validation won't work, so we need to temporary remove lock, then
      // validate and finally re-enable if necessary
      const wasLocked = columnsMapLocked.value;
      columnsMapLocked.value = false;
      await nextTick();
      return root.proxy.$validator.validateAll('settings_form').then((r) => {
        columnsMapLocked.value = wasLocked;
        return r;
      });
    }

    const isRequired = (item) => {
      return !['Secondary Case Manager', 'Gender'].includes(item.label)
    }

    return {
      newCustomField,
      editCustomField,
      setColumnsMapLock,
      customFieldModalShow,
      editCustomFieldModalShow,
      destroyCustomColumn,
      editingCustomColumnIndex,
      editingCustomColumnFieldName,
      filteredColumnsMap,
      valueMap,
      columnsMapLocked,
      fieldOptions,
      validateAll,
      isRequired,
    }
  }
}

</script>

<style scoped lang="scss">
i {
  cursor: pointer;

  & :hover {
    color: #d09f23;
  }
}

.options-gear {
  display: inline-block;
  padding: 0px 5px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// VueMapData.vue?2c0ed7fd